// Cookie consent — RODO compliant banner.
// Storage: localStorage `kb_consent` (1-year TTL via cookie też dla SSR).
// Format wartości: {"functional":true,"analytics":true,"marketing":false,"ts":1718000000}
// Wystawia globalny `window.kbConsent` z {functional, analytics, marketing} dla
// innych skryptów (np. GA4 init only if consent.analytics === true).

(function () {
  if (typeof document === 'undefined') return;

  const KEY = 'kb_consent';
  const COOKIE_NAME = 'kb_consent';
  const TTL_DAYS = 365;
  const CURRENT_VERSION = 1; // bump gdy zmieniamy kategorie/tekst → wymaga re-consent

  // ── Storage helpers ─────────────────────────────────────────────────
  function readConsent() {
    try {
      const raw = localStorage.getItem(KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data && data.v === CURRENT_VERSION) return data;
      return null; // stale version → re-consent
    } catch (_) {
      return null;
    }
  }

  function writeConsent(consent) {
    const data = Object.assign({ v: CURRENT_VERSION, ts: Math.floor(Date.now() / 1000) }, consent);
    try { localStorage.setItem(KEY, JSON.stringify(data)); } catch (_) { /* noop */ }
    // Cookie equivalent (SSR / server-side checks)
    const exp = new Date();
    exp.setDate(exp.getDate() + TTL_DAYS);
    const cookieVal = encodeURIComponent(JSON.stringify(data));
    document.cookie = COOKIE_NAME + '=' + cookieVal + '; expires=' + exp.toUTCString() + '; path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '');
    // Globalny obiekt dla innych skryptów
    window.kbConsent = { functional: true, analytics: !!data.analytics, marketing: !!data.marketing };
    // Custom event → dla GA4 / Pixel skryptów, mogą się podpiąć i (re)inicjalizować
    document.dispatchEvent(new CustomEvent('kb:consent-updated', { detail: window.kbConsent }));
  }

  // ── WooCommerce Order Attribution (sourcebuster) ─────────────────────
  // WooCommerce śledzi źródło zamówienia (Google / Facebook / mail) biblioteką
  // sourcebuster.js, która zapisywała 7 cookies `sbjs_*` NATYCHMIAST po wejściu,
  // zanim ktokolwiek kliknął zgodę. Consent Mode ich nie obejmuje, bo to nie są
  // tagi Google.
  //
  // Rozwiązanie idzie oficjalnym API WooCommerce: filtr PHP
  // `wc_order_attribution_allow_tracking` ustawia domyślnie `false` (bezpieczne
  // przy cache'u pełnych stron, bo HTML jest wtedy taki sam dla wszystkich),
  // a tutaj włączamy śledzenie dopiero po zgodzie. `setOrderTracking(false)`
  // dodatkowo KASUJE już zapisane cookies, więc wycofanie zgody działa wstecz.
  //
  // Skrypt `wc-order-attribution` ładuje się w stopce, więc przy pierwszym
  // wywołaniu może go jeszcze nie być — stąd krótki retry zamiast pojedynczej próby.
  function applyOrderAttributionConsent(allowed, tries) {
    const api = window.wc_order_attribution;
    if (api && typeof api.setOrderTracking === 'function') {
      try { api.setOrderTracking(!!allowed); } catch (_) { /* noop */ }
      return;
    }
    if ((tries || 0) < 20) {
      setTimeout(() => applyOrderAttributionConsent(allowed, (tries || 0) + 1), 250);
    }
  }
  document.addEventListener('kb:consent-updated', (e) => {
    // Atrybucja źródła zamówienia to cel marketingowy, nie analityczny.
    applyOrderAttributionConsent(!!(e.detail && e.detail.marketing), 0);
  });

  // ── UI ──────────────────────────────────────────────────────────────
  function getEls() {
    const root = document.getElementById('kb-cookie-banner');
    if (!root) return null;
    return {
      root,
      bar: root.querySelector('[data-kb-cookie-bar]'),
      settingsPanel: root.querySelector('[data-kb-cookie-settings-panel]'),
      settingsBtn: root.querySelector('[data-kb-cookie-settings]'),
      acceptBtn: root.querySelector('[data-kb-cookie-accept]'),
      rejectBtn: root.querySelector('[data-kb-cookie-reject]'),
      saveBtn: root.querySelector('[data-kb-cookie-save]'),
      catAnalytics: root.querySelector('input[data-kb-cookie-cat="analytics"]'),
      catMarketing: root.querySelector('input[data-kb-cookie-cat="marketing"]'),
    };
  }

  function show(els) {
    els.root.classList.remove('opacity-0', 'translate-y-full', 'pointer-events-none');
    els.root.classList.add('is-visible');
    els.root.setAttribute('aria-hidden', 'false');
  }

  function hide(els) {
    els.root.classList.add('opacity-0', 'translate-y-full', 'pointer-events-none');
    els.root.classList.remove('is-visible');
    els.root.setAttribute('aria-hidden', 'true');
  }

  function showSettings(els) {
    if (els.settingsPanel) els.settingsPanel.classList.remove('hidden');
    if (els.bar) els.bar.classList.add('hidden');
  }

  function hideSettings(els) {
    if (els.settingsPanel) els.settingsPanel.classList.add('hidden');
    if (els.bar) els.bar.classList.remove('hidden');
  }

  // ── Init ────────────────────────────────────────────────────────────
  function init() {
    const els = getEls();
    if (!els) return;

    const existing = readConsent();
    if (existing) {
      // Zapisana zgoda — globaInie ustaw + nie pokazuj banneru
      window.kbConsent = { functional: true, analytics: !!existing.analytics, marketing: !!existing.marketing };
      document.dispatchEvent(new CustomEvent('kb:consent-updated', { detail: window.kbConsent }));
      return;
    }

    // Brak zgody → pokaż banner (RAF żeby tranzycja się odpaliła)
    requestAnimationFrame(() => show(els));

    // Accept all
    if (els.acceptBtn) {
      els.acceptBtn.addEventListener('click', () => {
        writeConsent({ functional: true, analytics: true, marketing: true });
        hide(els);
      });
    }

    // Reject (tylko niezbędne)
    if (els.rejectBtn) {
      els.rejectBtn.addEventListener('click', () => {
        writeConsent({ functional: true, analytics: false, marketing: false });
        hide(els);
      });
    }

    // Toggle settings panel
    if (els.settingsBtn) {
      els.settingsBtn.addEventListener('click', () => {
        showSettings(els);
      });
    }

    // Save custom
    if (els.saveBtn) {
      els.saveBtn.addEventListener('click', () => {
        const analytics = !!(els.catAnalytics && els.catAnalytics.checked);
        const marketing = !!(els.catMarketing && els.catMarketing.checked);
        writeConsent({ functional: true, analytics, marketing });
        hide(els);
        hideSettings(els);
      });
    }
  }

  // ── Re-open helper (np. link „Zmień ustawienia cookies" w stopce) ──
  // Dowolny element z `[data-kb-cookie-reopen]` po kliku otworzy banner.
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-kb-cookie-reopen]');
    if (!trigger) return;
    e.preventDefault();
    const els = getEls();
    if (els) {
      // Pre-check checkboxy z aktualnej zgody
      const existing = readConsent();
      if (existing) {
        if (els.catAnalytics) els.catAnalytics.checked = !!existing.analytics;
        if (els.catMarketing) els.catMarketing.checked = !!existing.marketing;
      }
      showSettings(els);
      show(els);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
